module.exports = __webpack_public_path__ + "img/trainingCenter-bg01.333283ab.png";